import { BfPageStoreState, EnumOption, EnumValue } from '@tw/tw-runtime';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import {
  ProductGoodsDTO,
  ProductOnGoingWelfareModel,
  ResAddressDTO,
  SaleOrderDTO,
  SaleOrderDeatilNodeModel
} from '@tw/clvip-api-gen';

/**
 * 初始化加载参数
 */
export interface CommonLoadParam {
  productType?: string;
  goodId?: string;
}

/**
 *
 */
export interface CommonStoreState extends BfPageStoreState {
  // 当前活动
  curActivity?: ProductOnGoingWelfareModel;

  // 当前活动的我的订单
  myCurActivityOrder?: SaleOrderDTO;

  goods?: ProductGoodsDTO[];
  // 商品列表的filter
  productType?: string;
  // 已选择商品
  selectedGoods: { good: ProductGoodsDTO; count: number }[];
  // 凑单时, 符合凑单条件的商品
  underUpperPriceGoods?: { good: ProductGoodsDTO; count: number }[];
  productTypeEnum: EnumValue[];
  // 零售产品类型枚举
  openPackageProductTypeEnums: EnumValue[];
  // 卡券类型枚举
  saleCardProductTypeEnums: EnumValue[];
  // 零售产品类型
  openPackageProductType: string;
  // 卡券类型
  saleCardProductType: string;
  // 已选商品总金额
  selectedGoodsAmount: number;
  // 礼包总金额
  welfareAmount: number;
  // 地址
  address: ResAddressDTO;
  // 零售时的filter
  filter?: string;
  // 是否包括零售商品 只要购物车里有零售商品，那么至少要选择300元的零售
  isContainOpenPackage?: boolean;
  // 零售商品的金额
  openPackageAmount?: number;
  // 是否选择300元的零售
  isContainOpenPackageOk: boolean;
  // 当前活动的我的订单的商品数据
  orderGoodsTreeData: SaleOrderDeatilNodeModel[];

  // 购物车弹窗是否可见
  cartPopupVisible: boolean;
  // 购物车加购弹窗是否可见
  addToCartPopupVisible: boolean;
  // 购物车加购请求中
  addToCartPopupLoading: boolean;

  // 加购类型
  // addToCartType?: string;

  // 主商品列表翻页 - 当前页
  pageNo: number;
  // 主商品列表翻页 - 每页条数
  pageSize: number;
  // 主商品列表翻页 - 总页数
  pageTotal: number;
  // 凑单品列表翻页 - 当前页
  // underUpperPriceGoodsPageNo: number;
}

// 零售商品的最低金额
export const MIN_OPEN_PACKAGE_AMOUNT = 500;
export type FilterType = 'all' | 'must';
export const RecommondType = 'recommond';

// 首页的推荐,商城,我的订单,我的订单的凑单,商品详情页,商城零售页面的凑单
export type AddGoodToCartType = 'recommend' | 'mall' | 'order' | 'underUpperPrice' | 'info' | 'openPackage';
export type DeleteGoodToCartType = 'order' | 'underUpperPrice';
export const DefaultOpenPackageProductType = 'all';
export const DefaultSaleCardProductType = 'all';

export const DefaultPageSize = 20;
